import PosterPlugin from './poster'
export default PosterPlugin
